import { EInternetStatusActionTypes, TInternetStatus } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить онлайн/оффлайн статус подключения
 */
export const setInternetStatus = actionGenerator<EInternetStatusActionTypes.Set, TInternetStatus>(
  EInternetStatusActionTypes.Set,
);
